import { render, staticRenderFns } from "./AttachEnrollmentDialog.vue?vue&type=template&id=3778b969&scoped=true"
import script from "./AttachEnrollmentDialog.vue?vue&type=script&lang=js"
export * from "./AttachEnrollmentDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3778b969",
  null
  
)

export default component.exports